import api from '../api';

/**
 * Upload a file to Cloudinary via backend-signed upload.
 * @param {File} file - The File object to upload
 * @param {string} folder - Cloudinary folder, must start with "eduva/"
 * @param {function} onProgress - Optional progress callback (0-100)
 * @returns {Promise<string>} The secure_url of the uploaded file
 */
export async function uploadToCloudinary(file, folder = 'eduva/uploads', onProgress) {
  // Get signed upload params from backend
  const sig = await api.get(`/cloudinary/signature?folder=${encodeURIComponent(folder)}`);

  const form = new FormData();
  form.append('file', file);
  form.append('api_key', sig.api_key);
  form.append('timestamp', sig.timestamp);
  form.append('signature', sig.signature);
  form.append('folder', sig.folder);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const data = JSON.parse(xhr.responseText);
        resolve(data.secure_url);
      } else {
        reject(new Error('Cloudinary upload failed'));
      }
    };

    xhr.onerror = () => reject(new Error('Network error during upload'));

    xhr.open('POST', `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`);
    xhr.send(form);
  });
}
